module.exports = __webpack_public_path__ + "836805d03f475bff1b2ce237d018f7ef.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/ga_zo_door_2.mp3
// module id = 62
// module chunks = 0